export const FilterTypes = {
    SelectSort: 1,
    RangeNumber: 2,
    CheckBox: 3,
    Switch: 4,
    Select: 5,
    RangeDate: 6,
    Input: 7
}
